export default __webpack_public_path__ + "static/media/fruit.b97fbda5.png";